<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;display: flex;flex-direction: column;">
        <div style="display: flex;">
            <el-date-picker v-model="search.time" type="daterange" value-format="yyyy-MM-dd" size="small" placeholder="时间范围" style="width: 215px;margin-right: 10px;" />
            <el-cascader v-model="search.depart" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true,multiple: true}" style="width: 300px;margin-left: 10px;" size="small" @visible-change="getDepartmentLists" placeholder="选择部门 "></el-cascader>
            <el-select v-model="search.admin_id" clearable filterable size="small" placeholder="选择员工" style="margin-left: 10px;" @visible-change="selectAdmin">
                <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
            </el-select>
            <el-select v-model="search.source" style="margin-left: 10px;" clearable size="small" placeholder="来源">
                <el-option v-for="(item,index) in sourceArr" :key="index" :label="item.name" :value="item.code"></el-option>
            </el-select>
            <el-select v-model="search.batch_id" style="margin-left: 10px;" clearable size="small" placeholder="批次" @visible-change="getBatchLists">
                <el-option v-for="(item,index) in batchArr" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select placeholder="商品类型" v-model="search.good_type" clearable size="small" style="width: 120px;margin-left: 10px;">
                <el-option label="标准商品" :value="1"></el-option>
                <el-option label="定制商品" :value="4"></el-option>
                <el-option label="礼品" :value="5"></el-option>
            </el-select>
            <div><el-button size="mini" style="margin-left: 10px;" @click="getUserFollowCount(1)">筛选</el-button></div>
        </div>
        <div style="flex: 1;display: flex;margin-top: 10px;">
            <div class="w200">
                <div id="myChart" style="width: 100%;height:200px;"></div>
                <div class="_flex _f_ai m_10" v-for="item in chart" :key="item.code">
                    <div class="p_2 h20 br_4" :style="{backgroundColor: item.color}"></div>
                    <div class="ml_5">{{item.name}}</div>
                    <div class="ml_a">{{item.value}}</div>
                    <div class="ml_10">{{item.percent}}<span class="c9 f_12 ml_2">%</span></div>
                </div>
            </div>
            <div style="flex: 1;">
                <el-table :data="list" height="100%" stripe :header-cell-style="{ background:'#f5f5f5'}" v-loading="loading" @sort-change="changeSort">
                    <el-table-column prop="id" label="序号" width="80">
                        <template v-slot="scope">{{scope.$index + 1}}</template>
                    </el-table-column>
                    <el-table-column prop="name" label="员工">
                        <template v-slot="{row}"> {{row.admin ? row.admin.nick_name : ''}}<br />{{row.depart}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="total" label="线索量" sortable></el-table-column>
                    <el-table-column v-for="item in stateArr" :key="item.code" :prop="'count_' + item.code" :label="item.name" sortable="custom">
                        <template v-slot="{row}"> {{row['count_' + item.code]}}<br />{{row['percent_' + item.code]}}% </template>
                    </el-table-column>
                    <el-table-column v-for="item in typeArr" :key="'type' + item.code" :prop="'type_' + item.code" :label="item.name" sortable="custom">
                        <template v-slot="{row}"> {{row['type_' + item.code]}}<br />{{row['typepercent_' + item.code]}}% </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <el-pagination style="margin-left: auto;" background layout="total, sizes, prev, pager, next, jumper"
            @size-change="changeLimit" @current-change="changePage" :current-page="search.page"
            :page-size="search.limit" :total="search.total"></el-pagination>
    </el-footer>
</el-container>
</template>

<script>
    import * as echarts from 'echarts';
    import { userFollowCount, batchLists, DepartmentLists, adminLists } from "@/request/apis.js"
    export default {
        data() {
            return {
                loading: false,
                name: '',
                list: [{ id: 1, name: '通知公告' }],
                show: false,
                represShow: false,
                formData: {
                    name: ''
                },
                stateArr: [],
                typeArr: [],
                sourceArr: [],
                departArr: [],
                adminList: [],
                batchArr: [],
                search: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    time: [],
                    depart: [],
                    admin_id: '',
                    source: '',
                    batch_id: '',
                    good_type: '',
                },
                chart: [],
            }
        },
        mounted() {
            // this.init()
            this.getUserFollowCount();
        },
        methods: {
            async getUserFollowCount(page, limit, order = {}) {
                this.search.page = page || this.search.page;
                this.search.limit = limit || this.search.limit;
                this.loading = true;
                var res = await userFollowCount({...this.search, ...order});
                this.loading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.list = res.data;
                this.search.total = res.count;
                this.stateArr = res.other.states;
                this.typeArr = res.other.types;
                this.sourceArr = res.other.source;
                this.chart = res.other.chart;
                this.search.time = res.other.time;

                var myChart = echarts.init(document.getElementById('myChart'));
                myChart.setOption(res.other.chartoption);
            },
            changeSort({prop, order}){
                console.log('changeSort', prop, order);
                if(order){
                    let t = {};
                    t[prop + '_sort'] = order;
                    this.getUserFollowCount(0, 0, t);
                }else{
                    this.getUserFollowCount();
                }
            },
            changeLimit(limit) {
                this.getUserFollowCount(1, limit);
            },
            changePage(page) {
                this.getUserFollowCount(page);
            },
            async getBatchLists(){
                var res = await batchLists({limit: 1000});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.batchArr = res.data;
            },
            async getDepartmentLists(query){
                if (!query || this.departArr.length) {
                    return false;
                }
                var res = await DepartmentLists();
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.departArr = res.data;
            },
            async selectAdmin(query){
                if (!query || this.adminList.length) {
                    return false;
                }
                const res = await adminLists({limit: 1000})
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },
            init() {
                //图一
                var myChart = echarts.init(document.getElementById('myChart'));
                myChart.setOption({
                    // title: {
                    //     text: '线索追踪',
                    //     left: 'left'
                    // },

                    title: {
                        text: '中间文字',
                        subtext: '副标题',
                        left: 'center',
                        top: 'middle',
                        textStyle: { color: '#333', fontSize: 20, fontWeight: 'bold' },
                        subtextStyle: { color: '#666', fontSize: 14 }
                    },

                    // title: [{
                    //     text: '左上角标题',
                    //     left: '5%',
                    //     top: 10,
                    //     textStyle: { color: '#666', fontSize: 14 }
                    // },
                    // {
                    //     text: '中间文字',
                    //     left: 'center',
                    //     top: 'middle',
                    //     textStyle: { color: '#333', fontSize: 20, fontWeight: 'bold' }
                    // }],
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['60%', '70%'],
                            avoidLabelOverlap: false,
                            label: { show: false, position: 'center', color: 'inherit' },
                            emphasis: { label: { show: true, fontSize: 20 } },
                            data: [
                                { value: 1048, name: '未分配线索' },
                                { value: 735, name: '已分配跟进中' }
                            ]
                        }
                    ]
                });
            }
        }
    }
</script>

<style scoped>
    p {
        margin: 0;
    }
</style>